import type * as React from 'react'

import { IconTile } from './icon-tile'
import { cn } from '@nwwp/ui-shadcn/lib/utils'

type FeatureIconItem = {
  label: string
  icon: React.ReactNode
}

type FeatureIconGridProps = {
  title?: string
  items: FeatureIconItem[]
  /** `rows` = icon left of label. `cards` = stacked icon cards. */
  variant?: 'rows' | 'cards'
  className?: string
}

function FeatureIconGrid({
  title = 'What can a financial advisor help with?',
  items,
  variant = 'rows',
  className,
}: FeatureIconGridProps) {
  const isRows = variant === 'rows'

  return (
    <section data-slot="feature-icon-grid" className={cn('flex flex-col gap-6', className)}>
      {title ? <h2 className="text-center text-title-xl text-foreground">{title}</h2> : null}
      <ul
        className={cn(
          isRows
            ? 'mx-auto grid w-full max-w-3xl grid-cols-1 gap-3 tablet:grid-cols-2'
            : 'grid grid-cols-2 gap-3 tablet:grid-cols-3'
        )}
      >
        {items.map(({ label, icon }, i) => (
          <li key={`${label}-${i}`}>
            <IconTile label={label} icon={icon} layout={isRows ? 'row' : 'stack'} />
          </li>
        ))}
      </ul>
    </section>
  )
}

export { FeatureIconGrid }
export type { FeatureIconGridProps, FeatureIconItem }
